module.exports = __webpack_public_path__ + "img/fig08.f380e222.jpg";